import VideoList from "../components/videos/VideoList";
import PageMeta from "../components/seo/PageMeta";
import { buildWebPageJsonLd } from "../lib/seo";
import "../styles/videos.css";

export default function VideosPage() {
  return (
    <>
      <PageMeta
        title="Videos"
        description="Films and video work by CJ Jayamaha — adventure, motorsport, wildlife, and stories from the road on YouTube."
        path="/videos"
        image="cjmeister-com-_DSC4977-Edit-Edit.jpg"
        keywords={["video", "YouTube", "films", "motorsport", "travel", "CJ Jayamaha"]}
        jsonLd={buildWebPageJsonLd({
          title: "Videos by CJ Jayamaha",
          description:
            "Films and video essays by CJ Jayamaha on adventure, motorsport, wildlife, and travel.",
          path: "/videos",
          image: "cjmeister-com-_DSC4977-Edit-Edit.jpg",
        })}
      />
      <VideoList />
    </>
  );
}
